import { http } from '@/network/http';
import type {
  AdminStats,
  Role,
  RoleListResponse,
  ActiveRolesResponse,
  MyPermissionsResponse,
  RoleFormData,
} from './types';

export const adminApi = {
  getStats: (month?: string, status?: string) =>
    http.get<{ success: boolean; stats: AdminStats }>('/dashboard/admin/stats', {
      params: { ...(month && { month }), ...(status && { status }) },
    }),

  // Roles
  getRoles: (params?: { page?: number; limit?: number; search?: string; isActive?: string }) =>
    http.get<RoleListResponse>('/roles', { params }),

  getAvailablePermissions: () =>
    http.get<{ success: boolean; tab: string[]; action: string[]; dataScope: string[] }>('/roles/available-permissions'),

  getActiveRoles: () =>
    http.get<ActiveRolesResponse>('/roles/active'),

  getMyPermissions: () =>
    http.get<MyPermissionsResponse>('/roles/my-permissions'),

  getRoleById: (id: string) =>
    http.get<{ success: boolean; role: Role }>(`/roles/${id}`),

  createRole: (data: RoleFormData) =>
    http.post<{ success: boolean; role: Role }>('/roles', data),

  updateRole: (id: string, data: Partial<RoleFormData>) =>
    http.put<{ success: boolean; role: Role }>(`/roles/${id}`, data),

  updateRolePermissions: (id: string, permissions: string[]) =>
    http.put<{ success: boolean; role: Role }>(`/roles/${id}/permissions`, { permissions }),

  deleteRole: (id: string) =>
    http.delete<{ success: boolean; message: string }>(`/roles/${id}`),
};
